"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalKVStore = void 0;
class LocalKVStore {
    constructor(_prefix) {
        this._prefix = _prefix;
    }
    get(key) {
        const k = this.prefix() + "/" + key;
        const data = localStorage.getItem(k);
        if (data === null) {
            return Promise.resolve(undefined);
        }
        return Promise.resolve(JSON.parse(data));
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        if (data === null) {
            return Promise.resolve(localStorage.removeItem(k));
        }
        return Promise.resolve(localStorage.setItem(k, JSON.stringify(data)));
    }
    prefix() {
        return this._prefix;
    }
}
exports.LocalKVStore = LocalKVStore;
//# sourceMappingURL=local.js.map